import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-inbuilt-visual-wrapper-v2',
  templateUrl: './inbuilt-visual-wrapper-v2.component.html',
  styleUrl: './inbuilt-visual-wrapper-v2.component.css',
  standalone: false
})
export class InbuiltVisualWrapperV2Component {
  @Input() heading = '';
  @Input() elementData: any = null;
  @Output() navigateRequest = new EventEmitter<any>();

  get hasNavigationLink(): boolean {
    return !!this.getActiveNavigationTarget();
  }

  get navigationTooltip(): string {
    const activeTarget = this.getActiveNavigationTarget();
    const tooltip = activeTarget?.toolTip ?? activeTarget?.tooltip ?? activeTarget?.ToolTip;
    return tooltip == null ? '' : String(tooltip).trim();
  }

  handleNavigationClick(): void {
    if (!this.hasNavigationLink) return;

    const navigationLink = this.elementData.navigationLink;
    this.navigateRequest.emit(navigationLink);
  }

  private getActiveNavigationTarget(): any {
    const navigationLink = this.elementData?.navigationLink;
    if (!navigationLink || typeof navigationLink !== 'object') {
      return null;
    }

    // Keep fallback keys for backward compatibility with older payloads.
    const candidates = [
      navigationLink.inReportLink,
      navigationLink.pageLink,
      navigationLink.externalLink,
    ];

    return candidates.find((candidate: any) => this.isObjectWithData(candidate)) || null;
  }

  private isObjectWithData(value: any): boolean {
    return !!value && typeof value === 'object' && Object.keys(value).length > 0;
  }

  
}
